import { TilesMatchHeight } from './../../Libraries/TilesMatchHeight'

/**
 * StaticTilesHeightMatcher
 */
export default class StaticTilesHeightMatcher {

    // constructor
    constructor(selector) {
        new TilesMatchHeight().execute();
    }

}